import { __ } from '@wordpress/i18n';

/**
 * Dashboard Header Component
 * Contains title, time filters, and export button
 * @param {string} timeRange - Current selected time range
 * @param {function} setTimeRange - Function to update time range
 */
const Header = ({ timeRange, setTimeRange }) => {
  const timeFilters = [
    { key: 'daily', label: __('Today', 'havenlytics') },
    { key: 'weekly', label: __('This Week', 'havenlytics') },
    { key: 'monthly', label: __('This Month', 'havenlytics') }
  ];

  return (
    <div className="hvnly-header">
      <h1 className="hvnly-title">
        <i className="fas fa-chart-network"></i>
        {__('Reports & Analytics', 'havenlytics')}
      </h1>
      <div className="hvnly-controls">
        <div className="hvnly-filter">
          {timeFilters.map(filter => (
            <button
              key={filter.key}
              className={`hvnly-filter-btn ${timeRange === filter.key ? 'active' : ''}`}
              onClick={() => setTimeRange(filter.key)}
            >
              {filter.label}
            </button>
          ))}
        </div>
        <button className="hvnly-action-btn">
          <i className="fas fa-download"></i>
          {__('Export Report', 'havenlytics')}
        </button>
      </div>
    </div>
  );
};

export default Header;